import Accordion from '01_core/components/layout/Accordion';
import { withCallAPI } from '01_core/components/system/CallAPI';
import { withCodeUtil } from '01_core/components/system/CodeUtil';
import { withRouter } from '01_core/components/system/CustomRouter';
import { HOME_USER_INFO, STATUS } from '01_core/constants/APIs';
import { CODE } from '01_core/constants/CodeConsts';
import { LABEL } from '01_core/constants/labelConsts';
import { STRING_CONSTS } from '01_core/constants/stringConsts';
import stringUtil from '01_core/logics/stringUtil';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import Button from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Domain from '@mui/icons-material/Domain';
import Home from '@mui/icons-material/Home';
import MailIcon from '@mui/icons-material/Mail';

import { HOME_DATA_KEY, TYPES, homeActions } from '../homeActions';
import { styles } from '../styles';

const stylesFromTheme = (theme) => (typeof styles === 'function' ? styles(theme) : styles);
const StyledUserInfoAccordion = styled(Accordion)(({ theme }) => stylesFromTheme(theme).userInfoAccordion || {});
const StyledUserInfo = styled('div')(({ theme }) => stylesFromTheme(theme).userInfo || {});
const StyledUserInfoButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'noUserInfo',
})(({ theme, noUserInfo }) => {
  const baseStyle = stylesFromTheme(theme).userInfoButton || {};
  const noInfoStyle = noUserInfo ? stylesFromTheme(theme).noUserInfoButton || {} : {};

  return {
    ...baseStyle,
    ...noInfoStyle,
  };
});
const StyledUserInfoText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'noUserInfo',
})(({ theme, noUserInfo }) => {
  const baseStyle = stylesFromTheme(theme).userInfoButtonText || {};
  const noInfoStyle = noUserInfo ? stylesFromTheme(theme).noUserInfo || {} : {};

  return {
    ...baseStyle,
    ...noInfoStyle,
  };
});
const StyledUserMailInfoText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'noUserInfo',
})(({ theme, noUserInfo }) => {
  const baseStyle = stylesFromTheme(theme).userMailInfoButtonText || {};
  const noInfoStyle = noUserInfo ? stylesFromTheme(theme).noUserInfo || {} : {};

  return {
    ...baseStyle,
    ...noInfoStyle,
  };
});
const StyledUserInfoButtonText = styled(Typography)(({ theme }) => stylesFromTheme(theme).userInfoButtonText || {});
const StyledUserInfoAuthority = styled(Typography)(({ theme }) => stylesFromTheme(theme).userInfoAuthority || {});

export class UserInfoField extends React.Component {
  constructor(props) {
    super(props);

    const { callAPI, setHomeData } = props;
    callAPI(HOME_USER_INFO).then((response) => {
      if (response.status === STATUS.SUCCESS) {
        setHomeData(HOME_DATA_KEY.USER_INFO_DATA, response);
      }
    });
  }

  onPersonalRegister = () => {
    this.props.history.push('/usercustom_personal_register');
  };

  render() {
    const { intl, userInfo, loginUserInfo, getCodeName } = this.props;
    let workTdfkName = userInfo.workTdfkCd
      ? getCodeName(CODE.TDFK.KBN, userInfo.workTdfkCd)
      : null;
    return (
      <StyledUserInfoAccordion
        title={loginUserInfo.shainNm}
        defaultExpanded={this.test}
      >
        <StyledUserInfo>
          <StyledUserInfoAuthority>{userInfo.authorityName}</StyledUserInfoAuthority>

          <StyledUserInfoButton
            variant='contained'
            color='default'
            noUserInfo={!workTdfkName || !userInfo.workSiteNm}
            onClick={this.onPersonalRegister}
          >
            <Domain htmlColor='black'/>

            <StyledUserInfoText noUserInfo={!workTdfkName || !userInfo.workSiteNm}>
              <b>
                {intl.formatMessage({ id: LABEL.CORE_WORK_PLACE })}
                {STRING_CONSTS.COLON_ZENKAKU}
              </b>
              {workTdfkName
                ? workTdfkName
                : intl.formatMessage({ id: LABEL.CORE_NOT_REGISTERED })}
              <br/>
              <b>
                {intl.formatMessage({ id: LABEL.CORE_BASE})}
                {STRING_CONSTS.COLON_ZENKAKU}
              </b>
              {userInfo.workSiteNm
                ? userInfo.workSiteNm
                : intl.formatMessage({ id: LABEL.CORE_NOT_REGISTERED })}
            </StyledUserInfoText>
          </StyledUserInfoButton>

          <StyledUserInfoButton
            variant='contained'
            color='default'
            onClick={this.onPersonalRegister}
          >
            <Home htmlColor='black'/>

            <StyledUserInfoButtonText>
              <b>
                {intl.formatMessage({ id: LABEL.CORE_HOME_PLACE })}
                {STRING_CONSTS.COLON_ZENKAKU}
              </b>
              {userInfo.homeTdfkCd
                ? getCodeName(CODE.TDFK.KBN, userInfo.homeTdfkCd)
                : intl.formatMessage({ id: LABEL.CORE_NOT_REGISTERED })}
            </StyledUserInfoButtonText>
          </StyledUserInfoButton>

          <StyledUserInfoButton
            variant='contained'
            color='default'
            onClick={this.onPersonalRegister}
          >
            <SvgIcon viewBox='0 -960 960 960' htmlColor='black'>
              <path d='M680-600h80v-80h-80v80Zm0 160h80v-80h-80v80Zm0 160h80v-80h-80v80ZM40-120v-400l280-200 280 200v400H400v-240H240v240H40Zm640 0v-440L400-762v-78h520v720H680Z' />
            </SvgIcon>

            <StyledUserInfoText>
              <b>
                {intl.formatMessage({ id: LABEL.CORE_OTHER_STAY_PLACE })}
                {STRING_CONSTS.COLON_ZENKAKU}
              </b>
              {userInfo.otherTdfkCd
                ? getCodeName(CODE.TDFK.KBN, userInfo.otherTdfkCd)
                : intl.formatMessage({ id: LABEL.CORE_NOT_REGISTERED })}
            </StyledUserInfoText>
          </StyledUserInfoButton>

          <StyledUserInfoButton
            variant='contained'
            color='default'
            noUserInfo={!userInfo.mailAddress1}
            onClick={this.onPersonalRegister}
          >
            <MailIcon htmlColor='black'/>

            <StyledUserMailInfoText noUserInfo={!userInfo.mailAddress1}
            >
              <b>
                {intl.formatMessage({ id: LABEL.CORE_MAIL_ADDRESS })}
              </b>
              <br/>
              {intl.formatMessage({ id: LABEL.CORE_MAIL_ADDRESS })}
              1
              {STRING_CONSTS.COLON_ZENKAKU}
              {userInfo.mailAddress1
                ? userInfo.mailAddress1
                : intl.formatMessage({ id: LABEL.CORE_NOT_REGISTERED })
              }
              <br/>
              {intl.formatMessage({ id: LABEL.CORE_MAIL_ADDRESS })}
              2
              {STRING_CONSTS.COLON_ZENKAKU}
              {userInfo.mailAddress2
                ? userInfo.mailAddress2
                : intl.formatMessage({ id: LABEL.CORE_NOT_REGISTERED })
              }
              <br/>
              {intl.formatMessage({ id: LABEL.CORE_MAIL_ADDRESS })}
              3
              {STRING_CONSTS.COLON_ZENKAKU}
              {userInfo.mailAddress3
                ? userInfo.mailAddress3
                : intl.formatMessage({ id: LABEL.CORE_NOT_REGISTERED })
              }
            </StyledUserMailInfoText>
          </StyledUserInfoButton>
            
          <StyledUserInfoAuthority>
            {intl.formatMessage({ id: LABEL.CORE_LAST_UPDATED_DATE })}
            {STRING_CONSTS.COLON_ZENKAKU}
              {userInfo.latestUpdDt
                ? stringUtil.emptyToHyphen(userInfo.latestUpdDt)
                : '-'
              }
          </StyledUserInfoAuthority>
        </StyledUserInfo>
      </StyledUserInfoAccordion>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    userInfo: state.home.homeData[HOME_DATA_KEY.USER_INFO_DATA]
      ? state.home.homeData[HOME_DATA_KEY.USER_INFO_DATA]
      : {},
    loginUserInfo: state.coreLoginInfo.loginUser[state.coreLocale.language],
    systemLink: state.coreLoginInfo.systemLink,
    sessionId: state.coreLoginInfo.sessionId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setHomeData: (fid, data) => dispatch(homeActions[TYPES.SET_HOME_DATA](fid, data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(withCallAPI(withCodeUtil(UserInfoField)))));
